module.exports = __webpack_public_path__ + "img/node-js.f8dab57d.png";